(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peeyo-reels"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.peeyo-reels__video').forEach((video) => {
    video.addEventListener('click', () => {
      const turningOn = video.muted;
      document.querySelectorAll('.peeyo-reels__video').forEach((other) => {
        other.muted = true;
      });
      video.muted = !turningOn;
      if (!video.muted) video.play();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
